// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"c6518f76","201":"47ab9472","558":"960d5529","611":"9d1e3eec","756":"49ec62f0","982":"9d297a57"}[chunkId] + ".chunk.js";
};